import axios from 'axios'
import { Cookies } from 'src/core/utils/cookies'

export function sendDataToTDS(data, query, ip, realRegion) {
  const payload = getTdsPayload(data, query, ip, realRegion)
  if (!payload) {
    return
  }

  axios
    .post('https://rptds.info/api/v1/postback/host/', payload)
    .then(() => {
      Cookies.set('clickID', data.click_id)
    })
    .catch(() => {})
}

export function getTdsPayload(data, query, ip, realRegion) {
  if (!data.click_id || !data.partner) {
    return
  }

  const payload = {
    clickID: data.click_id,
    last_clickID: Cookies.get('clickID') || '',
    partner: data.partner,
    source: data.source || '',
    landing: data.landing || '',
    referrer: document.referrer,
    time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    lang_code: navigator.language,
    country_code: realRegion,
    client_ip: ip,
    current_domain: location.origin + location.pathname,
  }

  if (data.pid) {
    payload.subpartner = data.pid
  }

  const dataKeys = ['click_id', 'partner', 'landing', 'pid']

  payload.queryset = Object.entries(query).reduce((previousValue, [key, value]) => {
    if (!dataKeys.includes(key)) {
      previousValue[key] = value
    }
    return previousValue
  }, {})

  return payload
}
